import React, { useState } from "react";
import { Row, Col, Grid, Flex, Button, Tooltip, Drawer } from "antd";

import CuttingLogicForm from "./components/CuttingLogicForm";
import CuttingLogicTable from "./components/CuttingLogicTable";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { fetchCuttingLogic, fetchManufacturers } from "./cuttingLogicThunk";
import { ArrowLeftOutlined, QuestionCircleOutlined } from "@ant-design/icons";
import QRParser from './components/QRParser';

const CuttingLogic = () => {

    const { useBreakpoint } = Grid;
    const screens = useBreakpoint();
    const dispatch = useDispatch();
    const navigate = useNavigate();

    useEffect(() => {

        dispatch(fetchManufacturers());

        dispatch(fetchCuttingLogic());

    }, [dispatch]);
    const [helpOpen, setHelpOpen] = useState(false);

    return (

        <div style={{ padding: 20 }}>

            <Flex
                justify="space-between"
                align="center"
                style={{ marginBottom: 16 }}
            >
                <Flex align="center" gap={8}>
                    <Button
                        type="text"
                        icon={<ArrowLeftOutlined style={{ fontSize: 18 }} />}
                        onClick={() => navigate(-1)}
                        data-testid="cutting-logic-back-button"
                    />
                    <h2
                        style={{
                            margin: 0
                        }}
                    >
                        Cutting Logic
                    </h2>
                </Flex>
                <Tooltip title="Help">
                    <Button
                        type="text"
                        icon={
                            <QuestionCircleOutlined
                                style={{
                                    fontSize: 18
                                }}
                            />
                        }
                        onClick={() => setHelpOpen(true)}
                    />
                </Tooltip>
            </Flex>

            <Row gutter={[16, 16]}>

                <Col span={24}>

                    <CuttingLogicForm />

                </Col>


                <Col span={24}>

                    <CuttingLogicTable />

                </Col>


                <Col span={24}>

                    <QRParser />

                </Col>

                <Drawer
                    title="Cutting Logic Help"
                    open={helpOpen}
                    onClose={() => setHelpOpen(false)}
                    width={450}
                    styles={{
          wrapper: {
            paddingTop: !screens.md ? "80px" : undefined
          }
        }}
                >

                    <div style={{ lineHeight: 1.8 }}>

                        <h2
                            style={{
                                fontSize: "18px",
                                fontWeight: 600,
                                paddingLeft: "14px",
                                marginBottom: "10px"
                            }}
                        >
                            Cutting Logic
                        </h2>

                        <div style={{ marginBottom: 24 }}>
                            <p
                                style={{
                                    margin: 0,
                                    color: "#555",
                                    paddingLeft: "14px",
                                    lineHeight: 1.7
                                }}
                            >
                                Cutting Logic allows configuring GS1 Application Identifier (AI)
                                positions for each manufacturer. These positions define where GTIN,
                                Batch, Expiry and Serial numbers are located inside a QR code or
                                barcode. The configured ranges are later used by the QR Parser module
                                to automatically extract values from scanned labels.
                            </p>
                        </div>


                        <div
                            style={{
                                background: "#f5f5f5",
                                padding: "14px",
                                borderRadius: "8px",
                                marginBottom: "16px"
                            }}
                        >

                            <strong>
                                How It Works
                            </strong>

                            <ol
                                style={{
                                    paddingLeft: "20px",
                                    marginTop: "10px"
                                }}
                            >

                                <li>Select Manufacturer</li>

                                <li>
                                    Configure character positions
                                    for GS1 AIs
                                </li>

                                <li>
                                    Define GTIN (01)
                                    start and end positions
                                </li>

                                <li>
                                    Define Batch (10)
                                    start and end positions
                                </li>

                                <li>
                                    Define Expiry (17)
                                    start and end positions
                                </li>

                                <li>
                                    Define Serial (21)
                                    start and end positions
                                </li>

                                <li>
                                    Save configuration
                                </li>

                                <li>
                                    Open QR Parser
                                </li>

                                <li>
                                    Select Manufacturer
                                </li>

                                <li>
                                    Paste or scan QR code
                                </li>

                                <li>
                                    System validates AIs
                                </li>

                                <li>
                                    Extract GTIN, Batch,
                                    Expiry and Serial values
                                </li>

                            </ol>

                        </div>


                        <div
                            style={{
                                background: "#fafafa",
                                border: "1px solid #eee",
                                padding: "14px",
                                borderRadius: "8px"
                            }}
                        >

                            <strong>
                                Important Notes
                            </strong>

                            <ul
                                style={{
                                    paddingLeft: "18px",
                                    marginTop: "10px",
                                    color: "#666"
                                }}
                            >

                                <li>

                                    AI 01 represents GTIN

                                </li>

                                <li>

                                    AI 10 represents Batch Number

                                </li>

                                <li>

                                    AI 17 represents Expiry Date

                                </li>

                                <li>

                                    AI 21 represents Serial Number

                                </li>

                                <li>

                                    Ranges must never overlap

                                </li>

                                <li>

                                    From value must be less than To

                                </li>

                                <li>

                                    Each manufacturer can have
                                    only one cutting logic

                                </li>

                                <li>

                                    QR Parser validates AI values
                                    before extracting data

                                </li>

                                <li>

                                    GTIN AI mismatch means the
                                    configured position does not
                                    contain AI code 01

                                </li>

                            </ul>

                        </div>


                        <div
                            style={{
                                background: "#fff7e6",
                                padding: "12px",
                                marginTop: "16px",
                                borderRadius: "8px",
                                border: "1px solid #ffd591"
                            }}
                        >

                            <strong>

                                Example

                            </strong>

                            <pre
                                style={{
                                    marginTop: "10px",
                                    whiteSpace: "pre-wrap"
                                }}
                            >

                                01 01234567890128
                                10 BATCH001
                                17 251231
                                21 SN987654

                            </pre>

                        </div>

                    </div>

                </Drawer>

            </Row>

        </div>

    );

};

export default CuttingLogic;